import React from 'react'
import { styled } from '@mui/material'
import { Card, Tooltip as BaseTooltip } from '@chilecompra/react-kit/components'

export const Box = styled(({ children, padding, ...props }) => <div {...props}>{children}</div>)`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: ${props => props.padding};
`

export const CustomCard = styled(Card)`
  &.MuiPaper-root {
    background: ${props => props.theme.palette.brand.white};
    border: 1px solid ${props => props.theme.palette.brand.gray2};
    border-radius: 4px;

    ${props => props.theme.breakpoints.up('sm')} {
      margin: 0 0 30px 0;
    }
  }
`

export const Info = styled(({ justifyContent, ...props }) => <div {...props} />)`
  align-items: center;
  color: ${props => props.theme.palette.brand.black1};
  cursor: initial;
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1.13px;
  line-height: normal;
  text-transform: uppercase;
  user-select: none;

  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 300px;
  }
`

export const QuestionIcon = styled('img')`
  height: 18px;
  margin: 0 0 -3px 6px;
  width: 18px;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 0.5rem 0;
  overflow: visible;
`

export const Tooltip = styled(BaseTooltip)`
  word-break: auto-phrase;
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    padding: 10px;
    margin: 10px;
    max-width: 335px;
    max-height: 100%;
    & > div {
      max-height: 100%;
    }
  }
`
